import { Dimensions } from 'react-native';
const style_validations = {
    backgroundColor: 'color',
    borderColor: 'color',
    overlayColor: 'color',
    tintColor: 'color',
    shadowColor: 'color',
    textShadowColor: 'color',
    color: 'color',
    backfaceVisibility: ['visible', 'hidden'],
    overflow: ['visible', 'hidden', 'scroll'],
    cursor: ['auto', 'pointer'],
    alignContent: ['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around', 'space-evenly'],
    alignItems: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
    alignSelf: ['auto', 'flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
    display: ['none', 'flex'],
    flexDirection: ['row', 'column', 'row-reverse', 'column-reverse'],
    flexWrap: ['wrap', 'nowrap', 'wrap-reverse'],
    justifyContent: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
    position: ['absolute', 'relative', 'static'],
    direction: ['inherit', 'ltr', 'rtl'],
    fontStyle: ['normal', 'italic'],
    fontWeight: ['normal', 'bold', 'light', 'medium', 'regular', 'semibold', 200, 400, 600, 800],
    textAlign: ['auto', 'left', 'right', 'center', 'justify'],
    textDecorationLine: ['none', 'underline', 'line-through', 'underline line-through'],
    textDecorationStyle: ['solid', 'double', 'dotted', 'dashed'],
    textTransform: ['none', 'capitalize', 'uppercase', 'lowercase'],
    userSelect: ['auto', 'none', 'text', 'contain', 'all'],
    borderCurve: ['circular', 'continuous'],
    borderStyle: ['solid', 'dotted', 'dashed'],
    pointerEvents: ['box-none', 'none', 'box-only', 'auto'],
    writingDirection: ['auto', 'ltr', 'rtl'],
    borderBottomLeftRadius: 'number',
    borderBottomRightRadius: 'number',
    borderRadius: 'number',
    borderTopLeftRadius: 'number',
    borderTopRightRadius: 'number',
    opacity: 'number',
    aspectRatio: 'number',
    borderBottomWidth: 'number',
    borderEndWidth: 'number',
    borderLeftWidth: 'number',
    borderRightWidth: 'number',
    borderStartWidth: 'number',
    borderTopWidth: 'number',
    borderWidth: 'number',
    bottom: 'number',
    end: 'number',
    flex: 'number',
    flexBasis: 'number',
    rowGap: 'number',
    gap: 'number',
    columnGap: 'number',
    flexGrow: 'number',
    flexShrink: 'number',
    height: 'number',
    left: 'number',
    margin: 'number',
    marginBottom: 'number',
    marginEnd: 'number',
    marginHorizontal: 'number',
    marginLeft: 'number',
    marginRight: 'number',
    marginStart: 'number',
    marginTop: 'number',
    marginVertical: 'number',
    maxHeight: 'number',
    maxWidth: 'number',
    minHeight: 'number',
    minWidth: 'number',
    padding: 'number',
    paddingBottom: 'number',
    paddingEnd: 'number',
    paddingHorizontal: 'number',
    paddingLeft: 'number',
    paddingRight: 'number',
    paddingStart: 'number',
    paddingTop: 'number',
    paddingVertical: 'number',
    right: 'number',
    start: 'number',
    top: 'number',
    width: 'number',
    zIndex: 'number',
    shadowOpacity: 'number',
    shadowRadius: 'number',
    fontSize: 'number',
    letterSpacing: 'number',
    lineHeight: 'number',
    textDecorationColor: 'number',
    textShadowRadius: 'number',
    borderBlockColor: 'number',
    borderBlockEndColor: 'number',
    borderBlockStartColor: 'number',
    borderBottomColor: 'number',
    borderBottomEndRadius: 'number',
    borderBottomStartRadius: 'number',
    borderEndColor: 'number',
    borderEndEndRadius: 'number',
    borderEndStartRadius: 'number',
    borderLeftColor: 'number',
    borderRightColor: 'number',
    borderStartColor: 'number',
    borderStartEndRadius: 'number',
    borderStartStartRadius: 'number',
    borderTopColor: 'number',
    borderTopEndRadius: 'number',
    borderTopStartRadius: 'number',
    elevation: 'number',
};
const styleKeys = {
    textDecoration: 'textDecorationLine'
};
export function convertStyle(str) {
    if (!str) {
        return {};
    }
    const result = {};
    str.replace(/[\s]+/g, '').split(';').forEach((item) => {
        if (item) {
            const match = item.split(':');
            let property = match[0].split('-').reduce((acc, key, i) => {
                if (i === 0) {
                    return `${acc}${key}`;
                }
                return `${acc.toLowerCase()}${key[0].toUpperCase()}${key.slice(1).toLowerCase()}`;
            }, '');
            match[1] = parseCSSValue(match[1]);
            if (styleKeys[property]) {
                property = styleKeys[property];
            }
            if (!style_validations[property]) {
                return;
            }
            const value = property !== 'fontWeight' && !isNaN(Number(match[1]))
                ? Number(match[1])
                : match[1];
            if (style_validations[property] === 'color') {
                if (isValidColor(value)) {
                    result[property] = value;
                }
            }
            else if (style_validations[property] === 'number') {
                if (typeof value === 'number' && !isNaN(value)) {
                    result[property] = value;
                }
            }
            else if (Array.isArray(style_validations[property])) {
                if (style_validations[property].includes(value)) {
                    result[property] = value;
                }
            }
        }
    });
    return result;
}
function parseCSSValue(value) {
    if (!value) {
        return value;
    }
    if (value.endsWith('vh')) {
        const result = Number(value.split('vh')[0]);
        if (!isNaN(result)) {
            const px = Dimensions.get('window').height / 100;
            return result * px;
        }
        else {
            return undefined;
        }
    }
    if (value.endsWith('em')) {
        const result = Number(value.split('em')[0]);
        if (!isNaN(result)) {
            return result * 16;
        }
        else {
            return undefined;
        }
    }
    if (value.endsWith('pt')) {
        const result = Number(value.split('pt')[0]);
        if (!isNaN(result)) {
            return result * 1.333;
        }
        else {
            return undefined;
        }
    }
    if (value.endsWith('px')) {
        const result = Number(value.split('px')[0]);
        if (!isNaN(result)) {
            return result;
        }
        else {
            return undefined;
        }
    }
    return value;
}
function isValidColor(color) {
    if (typeof color !== 'string') {
        return false;
    }
    const hexRegex = /^#([0-9A-Fa-f]{3,4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
    const rgbRegex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(0|0?\.\d+|1(\.0+)?)\s*)?\)$/;
    if (hexRegex.test(color)) {
        return true;
    }
    const match = color.match(rgbRegex);
    if (match) {
        const [r, g, b, a] = match.slice(1).map(Number);
        return r <= 255 && g <= 255 && b <= 255 && (a === undefined || (a >= 0 && a <= 1));
    }
    return false;
}
